import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronCell } from 'components/Table';
import Tooltip from 'components/Tooltip/Tooltip';
import { useSelector } from 'store';

import './DisabledChevronCell.scss';

const DisabledChevronCell = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);

  if (isLoggedIn) {
    return <ChevronCell />;
  }

  return (
    <Tooltip tooltip={t('pages.prosforaProject.pleaseLogInForDetails')}>
      <div className="enkrateia-disabled-chevron-cell">
        <ChevronCell />
      </div>
    </Tooltip>
  );
};

export default DisabledChevronCell;
